//function for counting values in array
function count_array_values(arr) {
    var a = [], b = [], prev;

    arr.sort();
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] !== prev) {
            a.push(arr[i]);
            b.push(1);
        } else {
            b[b.length - 1]++;
        }
        prev = arr[i];
    }

    return [a, b];
}

jQuery(document).ready(function($) {
    $('.js-add-participant .btn').click(function(e) {
        e.preventDefault();
        var $fields = $(this).parent().siblings('.js-participant-field');

        if (!$(this).hasClass('added')) {
            $fields.fadeIn(200);
            $(this).addClass('added').html('<i class="fas fa-minus"></i> Teilnehmer entfernen');
            $(this).parent().find('.js-hidden-field').val('added');
        } else {
            $fields.hide().find('.form-control').val('');
            $(this).removeClass('added').html('<i class="fas fa-plus"></i> Weiteren Teilnehmer hinzufügen');
            $(this).parent().find('.js-hidden-field').val('');
        }

    });

    $('.js-delete-participant').click(function() {

        var count = parseInt($('.seminar-bundle-persons').text());
        var price = parseInt($('.seminar-bundle-price').text());

        $(this).parents('.form-group').find('.js-participant-field').hide().find('.form-control').val('');
        $(this).parents('.form-group').find('.btn').removeClass('added').html('<i class="fas fa-plus"></i> Weiteren Teilnehmer hinzufügen');
        $(this).parents('.form-group').find('.js-hidden-field').val('');

        count--;
        $('.seminar-bundle-persons').text(count);
        $('.seminar-bundle-summary').text(price * count);

    });

    //Submit Form

    $('.js-registrationform').submit(function(event) {

        var action_url = '/cms/wp-admin/admin-ajax.php?action=send_form';
        var formData = $(this).serializeArray();

        $.ajax({
            type: 'POST',
            url: action_url,
            data: formData
        }).done(function(data) {

            var response = JSON.parse(data);

            $('.invalid').removeClass('invalid');
            $('.message').remove();

            if (!response.success) {

                var errors = response.errors;

                if (Array.isArray(errors)) {

                    var message = "";

                    for (var i = 0; i < errors.length; i++) {

                        if (errors[i] == 'agb') {
                            message = 'Bitte akzeptieren Sie die AGB.';

                        } else if (errors[i] == 'privacy') {
                            message = 'Bitte akzeptieren Sie die Datenschutzbestimmungen.';

                        } else {
                            message = 'Dies ist ein Pflichtfeld. Bitte machen Sie eine Angabe.';
                        }

                        $('input[name=' + errors[i] + ']').addClass('invalid').parent().append('<span class="message">' + message + '</span>');
                    }

                    $('html, body').animate({
                        scrollTop: $('#' + errors[0]).offset().top - 100
                    }, 800);

                } else {
                    $('.module-registrationform').append('<div id="confirmation" class="confirmation-overlay"><h2>Tut uns leid</h2><p>Die E-Mail konnte nicht abgeschickt werden.</p><p>Bitte versuchen Sie es zu einem späteren Zeitpunkt nochmal.</p></div>');
                    $('.js-registrationform').hide();

                    $('html, body').animate({
                        scrollTop: $('#confirmation').offset().top - 100
                    }, 800);
                }

            } else {
                $('.module-registrationform').append('<div id="confirmation" class="confirmation-overlay"><h2>Vielen Dank für Ihre Anmeldung</h2><p>Schön, dass Sie sich für ein Seminar entschieden haben.<br>Ihre Anmeldung wird umgehend geprüft.</p><p>Eine Anmeldebestätigung wird innerhalb von einem Arbeitstag per E-Mail an die angegebene E-Mail-Adresse versendet.</p><p>Die Anmeldebestätigung enthält außerdem die Uhrzeiten des Seminars sowie eine Anreisebeschreibung zum Seminarhotel. Kann eine Anmeldung nicht berücksichtigt werden, so wird dies umgehend mitgeteilt.</p></div>');
                $('.js-registrationform').hide();

                $('html, body').animate({
                    scrollTop: $('#confirmation').offset().top - 100
                }, 800);
            }

        });
        event.preventDefault();
    });

    //set price for current date
    var price = parseInt($('.seminar-bundle-price').text());

    $('.form-group-bundle label').click(function() {

        var $input = $(this).prev();

        //get data-attributes
        var seminar_price = parseInt($input.data('price'));
        var seminar_name = $input.data('name');
        var seminar_date = $input.data('date');
        var id = $input.data('id');

        var bundle_price = price;
        var count = parseInt($('.seminar-bundle-persons').text());

        //check if input is in group
        var is_in_group = $(this).parent().siblings().length;

        //empty discount field
        var discount = 0;
        $('.discount').empty();


        if ($input.hasClass('checked')) {
            $input.removeClass('checked').prop('checked', false);
        } else {
            $input.addClass('checked').prop('checked', true);
        }


        if ($input.hasClass('checked')) {

            var sib_price = 0;
            var sib_id = null;
            var $sib = $(this).parent().siblings().find('input');

            if (is_in_group >= 2 && $sib.hasClass('checked')) {

                //uncheck all other elements in group
                $sib.each(function() {

                    sib_id = $(this).data('id');
                    sib_price = -parseInt($(this).data('price'));
                    $(this).removeClass('checked').prop('checked', false);

                    $('tr[rel="' + sib_id + '"]').remove();

                });

            }

            price = sib_price + seminar_price + bundle_price;

            $('<tr rel="' + id + '" class="table-section added-seminar"><td colspan="2">' + seminar_name + ' (' + seminar_date + ') ' + '</td></tr>').insertAfter('.seminar-bundle-name');

        } else {

            price = bundle_price - seminar_price;
            $('tr[rel="' + id + '"]').remove();
        }

        // to be sure it's full price only
        discount = 0;

        //set full price
        $('.seminar-bundle-price').text(price - discount + ' €');
        $('.seminar-bundle-summary').text(count * (price - discount) + ' €');


    });

    $('.js-add-participant button').click(function() {

        var count = parseInt($('.seminar-bundle-persons').text());
        var price = parseInt($('.seminar-bundle-price').text());

        if ($(this).hasClass('added')) {
            count++;
        } else {
            count--;
        }

        $('.seminar-bundle-persons').text(count);
        $('.seminar-bundle-summary').text(price * count + ' €');
    });

    $('.styled-select').selectric();

});

